export function getIsCroft() {
    const env = process.env.REACT_APP_IS_CROFT;
    
    if (typeof env === "undefined") return window.location.hostname.toLowerCase() === "register.croftcircuit.co.uk";
    return env === "1";
}